// extracted by mini-css-extract-plugin
module.exports = {"container":"Recruiter_container__p9zNY","sidebar":"Recruiter_sidebar__i_D5D","main":"Recruiter_main__KXEiO","form":"Recruiter_form__ClY5v"};